
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Loading from 'vux/src/components/loading/index.vue'

import store from '../../vuex/store'
import { go } from '../../libs/router'
import wx from 'weixin-js-sdk'
export default {
components: {
XInput,
XButton,
Group,
Cell,
Alert,
Toast,
Loading
},
data () {
return {
loadingShow: false,
loadingText: '保存中',
qrCode: '',
invoiceId: '',
dataDetail: {},
type: '',
wxReady: false,
localIds: [],
imgIds: [],
warnMsgShow: false,
warnMsg: '',
toastShow: false,
toastMsg: ''
}
},
mounted () {
store.commit( 'UPDATE_TITLE', '发票详情' )
},
created () {
var _this = this
store.commit( 'UPDATE_SHOW_FOOTER', false )
_this.invoiceId = _this.$route.params.id
var param = {
id: _this.invoiceId
}
_this.$ajax.post( _this.ajaxFactory.get( 'showInvoiceDetail' ), {}, {
params: param
} ).then( function ( response ) {
var result = response.data
if ( result.code === '200' ) {
_this.dataDetail = result
if ( result.type === '01' ) {
_this.type = '增值税专用发票'
} else if ( result.type === '02' ) {
_this.type = '货运运输业增值税专用发票'
} else if ( result.type === '03' ) {
_this.type = '机动车销售统一发票'
} else if ( result.type === '04' ) {
_this.type = '增值税普通发票'
} else if ( result.type === '10' ) {
_this.type = '增值税电子发票（电子）'
} else if ( result.type === '11' ) {
_this.type = '增值税电子发票（卷式）'
} else {
_this.type = '增值税电子发票'
}
} else if ( result.code === '500' ) {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} ).catch( function ( response ) {
console.log( response )
} )
},
methods: {
onClick ( link ) {
go( link, this.$router )
},
uploadImg () {
var _this = this
if ( _this.localIds.length === 5 ) {
_this.warnMsgShow = true
_this.warnMsg = '图片数量不能超过5张'
return
}
wx.chooseImage( {
count: 1,
sizeType: ['compressed'],
success: function ( res ) {
var localIds = res.localIds
for ( var z = 0; z < localIds.length; z++ ) {
if ( _this.isAndroid ) {
_this.localIds.push( localIds[z] )
} else {
_this.getIosImg( localIds[z] )
}
wx.uploadImage( {
localId: localIds[z], // 需要上传的图片的本地ID，由chooseImage接口获得
isShowProgressTips: 1, // 默认为1，显示进度提示
success: function ( res ) {
var serverId = res.serverId
var param = {
serverId: serverId,
invoiceInfoId: _this.dataDetail.invoiceBaseInfo.id,
invoiceCode: _this.dataDetail.invoiceBaseInfo.invoiceCode,
invoiceNo: _this.dataDetail.invoiceBaseInfo.invoiceNo,
invoiceDate: _this.dateFilter( _this.dataDetail.invoiceBaseInfo.invoiceDate, 'yyyy-MM-dd' )
}

_this.$ajax.post( _this.ajaxFactory.get( 'saveImg' ), {}, {
params: param
} ).then( function ( response ) {

var result = response.data
if ( result.code === '200' ) {
_this.imgIds.push( result.imageId )
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}
} ).catch( function ( response ) {
console.log( response )
} )
}
} )
}
}
} )
},
save () {
var _this = this
if ( _this.localIds.length > 5 ) {
_this.warnMsgShow = true
_this.warnMsg = '图片数量不能超过5张'
return
}
if ( _this.imgIds.length === 0 ) {
_this.warnMsgShow = true
_this.warnMsg = '请至少上传一张图片'
return
}
var param = {
ids: _this.imgIds.join()
}
_this.loadingShow = true
_this.$ajax.post( _this.ajaxFactory.get( 'saveImgWithUser' ), {}, {
params: param
} ).then( function ( response ) {
var result = response.data
_this.loadingShow = false
if ( result.code === '200' ) {
_this.toastShow = true
_this.toastMsg = '保存成功'
setTimeout( function () {
window.history.go( -1 )
}, 3000 )
} else {
_this.warnMsgShow = true
_this.warnMsg = result.msg
}

console.log( _this.localIds )
} )
.catch( function ( response ) {
_this.loadingShow = false
console.log( response )
} )
},
deleteImg ( index ) {
this.localIds.splice( index, 1 )
this.imgIds.splice( index, 1 )
},
getIosImg ( id ) {
var _this = this
wx.getLocalImgData( {
localId: id, // 图片的localID
success: function ( res ) {
_this.localIds.push( res.localData )
}
} )
}
},
computed: {
isAndroid: function () {
var u = navigator.userAgent
return u.indexOf( 'Android' ) > -1 || u.indexOf( 'Adr' ) > -1
}
}
}



// WEBPACK FOOTER //
// ./src/components/fpj/scptfp.vue